<template>
	<div id="enableTwoFactorAuthentication" class="contentLogin">
		<div :class="[isMobile ? 'modLogin mobile' : 'modLogin']">
			<div class="p-3 mb-5 mt-4 bg-white rounded-2 box-shadow fw-500">

				<div class="logo-login">
					<img src="~@/assets/img/logo-fundo-transparente.svg">
				</div>

				<div class="row mt-4 mr-5 mb-4">
					<div class="col-1"></div>
					<div class="col-1 ml-3"><img src="~@/assets/img/icon-prev.svg" class="pointer imagePrev" @click="toFirstAccess"></div>
					<div class="col-10" style="margin-left: 85px; margin-top: -35px;">
						<p class="titleAuthentication">{{$t('login_two_factor_authentication')}}</p>
					</div>
				</div>

				<div class="row">
					<div class="col-1"></div>
					<div class="col-1 ml-3"><p class="fw-500">1. </p></div>
					<div class="col-8">
						<p class="fw-400">
							{{$t('login_text_one_part_one_authentication')}}
							{{$t('login_text_one_part_two_authentication')}}
							<b>{{$t('login_microsoft_authenticator')}}</b>,
							<b>{{$t('login_google_authenticator')}}</b> {{$t('login_or')}}
							<b>{{$t('login_duo_authenticator')}}</b>.
						</p>
					</div>
					<div class="col-2"></div>
				</div>

				<div class="row">
					<div class="col-1"></div>
					<div class="col-1 ml-3"><p class="fw-500">2. </p></div>
					<div class="col-8">
						<p class="fw-400">
							{{$t('login_text_two_authentication')}}
						</p>
					</div>
					<div class="col-2"></div>
				</div>

				<div class="row mb-4">
					<div class="col-2"></div>
					<div class="col-8">
						<img class="ml-3" :src="urlGToken" alt="QRCode Token">
					</div>
					<div class="col-2"></div>
				</div>

				<form id="form_two_factor" name="form_two_factor" v-on:submit.prevent="onSubmit">
					<InputOtp :numInputs="6" :label="$t('login_enter_code')" :fromAuthentication=true @update:updateToken="updateToken"/>

					<div class="row mt-5 mb-4">
						<div class="col-2"></div>
						<div class="col-8">
							<input
								type="submit"
								class="form-control btnVerification"
								id="btn_validate_token"
								:value="$t('login_validate_token')"
								@click="firstLogin()"
								:disabled="disabled"
							>
						</div>
						<div class="col-2"></div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import InputOtp from './composables/InputOtp.vue';

import loginControl from '@/mixins/Login/loginControl';
import isMobileControl from '@/mixins/Login/isMobileControl';

export default {
	name: 'EnableTwoFactorAuthentication',

	mixins: [
		loginControl,
		isMobileControl
	],

	components: {
		InputOtp
	},

	data (){
		return {
			username: null,
			password: null,
			tokens: null,
			urlGToken: null,
			disabled: true,
			isSuper: false
		}
	},

	created(){
		this.username = this.$route.params.username;
		this.password = this.$route.params.password;
		this.urlGToken = this.$route.params.urlGToken;
		this.isSuper = this.$route.params.isSuper;

		if (typeof this.urlGToken == "undefined" && this.urlGToken == null) {
			this.toFirstAccess();
		}

		this.setLanguage();
	},

	watch: {
		tokens() {
			this.disabled = true;
			if (this.tokens.length == 6) {
				this.disabled = false;

				this.$nextTick(() => {
					this.focus("btn_validate_token");
				});
			}
		}
	},
}
</script>

<style lang="scss" scoped>
	::v-deep .modLogin::-webkit-scrollbar {
		width: 12px; // Largura da barra de rolagem (https://developer.mozilla.org/pt-BR/docs/Web/CSS/::-webkit-scrollbar)
	}

	::v-deep .modLogin::-webkit-scrollbar-thumb {
		background-color: transparent; // Cor do polegar da barra de rolagem (https://developer.mozilla.org/pt-BR/docs/Web/CSS/::-webkit-scrollbar)
	}

	::v-deep .modLogin::-webkit-scrollbar-track {
		background-color: transparent; // Cor da trilha da barra de rolagem (https://developer.mozilla.org/pt-BR/docs/Web/CSS/::-webkit-scrollbar)
	}

	::v-deep .titleAuthentication {
		font-size: x-large;
	}

</style>
